module.exports = __webpack_public_path__ + "77be4155eb52f3896dd5c5a7db22a147.svg";